import React, { useEffect, useState } from "react";
import { Button, Snackbar } from "@material-ui/core";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";

import {
  enableOrderNotifications,
  initializeOrderNotifications,
} from "../services/orderNotifications";

export default function OrderNotificationControl() {
  const [enabled, setEnabled] = useState(
    typeof Notification !== "undefined" && Notification.permission === "granted",
  );
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    initializeOrderNotifications()
      .then((result) => setEnabled(result.enabled))
      .catch((error) => {
        setEnabled(false);
        setMessage(error.message);
      });

    const handleNewOrder = (event) => {
      setMessage(`${event.detail.title}: ${event.detail.body}`);
    };

    window.addEventListener("newOrderNotification", handleNewOrder);
    return () => window.removeEventListener("newOrderNotification", handleNewOrder);
  }, []);

  const handleEnable = async () => {
    try {
      setLoading(true);
      const result = await enableOrderNotifications({ askPermission: true });
      setEnabled(result.enabled);
      setMessage(
        result.enabled
          ? "New-order notifications are enabled."
          : "Notification permission was not granted.",
      );
    } catch (error) {
      setMessage(error.message || "Could not enable notifications.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        size="small"
        color={enabled ? "primary" : "default"}
        startIcon={<NotificationsActiveIcon />}
        onClick={handleEnable}
        disabled={loading}
        style={{ marginRight: 16 }}
      >
        {loading ? "Enabling..." : enabled ? "Order alerts on" : "Enable order alerts"}
      </Button>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(message)}
        autoHideDuration={6000}
        onClose={() => setMessage("")}
        message={message}
      />
    </>
  );
}
